const projets = [
  {
    id: 1,
    name: "Application SaaS - Feel Agile",
    image: "stellar.png",
    description:
      "Développement d'une application SaaS complète de gouvernance, risques et conformité informatique. Interface utilisateur moderne avec React/TypeScript et API robuste avec Laravel. Gestion des utilisateurs, tableaux de bord interactifs, et système de reporting avancé.",
    creation: "2022-2023",
    technos: ["React", "TypeScript", "Laravel", "PostgreSQL", "TailwindCSS"],
    isApp: false,
    category: "Web Application",
    github: null,
    demo: null,
    highlight: false,
    type: "Projet d'entreprise",
  },
  {
    id: 2,
    name: "Portfolio 3D Interactif",
    image: "portfolio.png",
    description:
      "Portfolio personnel développé avec React et Three.js, proposant une expérience immersive en 3D sur desktop et une version optimisée mobile. Intégration de modèles 3D, animations fluides et interface responsive moderne.",
    creation: "2023",
    technos: ["React", "Three.js", "@react-three/fiber", "TailwindCSS"],
    isApp: false,
    category: "Portfolio",
    github: null,
    demo: window.location.origin,
    highlight: false,
    type: "Projet perso",
  },
  {
    id: 3,
    name: "Tanso",
    image: "tanso.png",
    description:
      "Application web de création musicale révolutionnaire développée avec Next.js. Interface intuitive basée sur des pads pour créer des rythmes et mélodies en quelques minutes. Bibliothèque de sons studio professionnels, effets intégrés, sauvegarde cloud et partage instantané. Workflow simplifié pour rendre la production musicale accessible à tous.",
    creation: "2025",
    technos: ["Next.js", "TypeScript", "TailwindCSS", "Web Audio API"],
    isApp: false,
    category: "Web Application",
    github: "https://github.com/achilledavid/tanso",
    demo: "https://tanso.achille-david.com/",
    highlight: true,
    type: "Projet de cours",
  },
  {
    id: 4,
    name: "Navia - Plateforme de Voyage",
    image: "navia.png",
    description:
      "Plateforme web complète de découverte et planification de voyages développée avec Next.js. Système de recommandation intelligent, quiz personnalisé pour trouver la destination idéale, gestion des voyages personnels, et exploration de destinations par pays. Interface moderne avec recherche avancée par budget, dates et préférences.",
    creation: "2024",
    technos: ["Next.js", "TypeScript", "TailwindCSS", "Prisma"],
    isApp: false,
    category: "Web Application",
    github: null, // Projet privé
    demo: "https://navia.achille-david.com/",
    highlight: true,
    type: "Projet de cours",
  },
  {
    id: 5,
    name: "Low Running - E-commerce",
    image: "low-running.png",
    description:
      "Plateforme e-commerce innovante de location de chaussures de running développée avec Next.js. Concept écologique et économique permettant de louer des chaussures premium plutôt que de les acheter. Système de recommandation personnalisé basé sur le profil de coureur, gestion des locations et interface moderne responsive.",
    creation: "2024",
    technos: ["Next.js", "TypeScript", "TailwindCSS", "Stripe"],
    isApp: false,
    category: "E-commerce",
    github: "https://github.com/fabienlpt/low-running",
    demo: "https://low-running.vercel.app/",
    highlight: true,
    type: "Projet de cours",
  },
  {
    id: 6,
    name: "Sereinus - App Mobile Santé",
    image: "sereinus.jpeg",
    description:
      "Application mobile révolutionnaire de gestion de crise d'angoisse conçue pour les jeunes actifs et étudiants. Premier outil de 'premier secours émotionnel' pensé pour l'usage en situation réelle : au travail, dans les transports, en cours ou en public. Interface ultra-discrète permettant une intervention en moins de 5 minutes sans stigmatisation sociale. Gestion avancée des capteurs (accéléromètre, gyroscope) pour détecter les tremblements et guider la respiration. Fonctionnement 100% hors-ligne avec sécurité renforcée et confidentialité absolue.",
    creation: "2025",
    technos: ["React Native", "TypeScript", "AsyncStorage"],
    isApp: true,
    category: "Mobile App",
    github: "https://github.com/fabienlpt/sereinus",
    demo: null,
    highlight: false,
    type: "Projet de cours",
  },
  {
    id: 7,
    name: "Portfolio Vincent Lapert",
    image: "portfolio-vincent.png",
    description:
      "Portfolio personnel de Vincent Lapert, développé avec Next et Typescript. Présentation de ses projets, compétences et expériences professionnelles dans un design moderne et responsive.",
    creation: "2024",
    technos: ["NextJs", "TypeScript"],
    isApp: false,
    category: "Portfolio",
    github: null,
    demo: "https://www.vincentlapert.com/",
    highlight: true,
    type: "Projet perso",
  },
];

export default projets;
